import utcToZonedTime from "date-fns-tz/utcToZonedTime";

export const isoToLocalDate = (str: string) =>
  utcToZonedTime(
    new Date(str?.[str.length - 1] !== "Z" ? `${str}Z` : str),
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
